export default __webpack_public_path__ + "static/media/jacket.df2bda38.jpg";